<div class="main-container">
  <div class="d-flex" [ngClass]="flexColumn? 'flex-column': ''">
    <div *ngFor="let item of items; let i = index" class="me-1 d-flex" [ngClass]="flexColumn? 'mb-1': ''">
      <input
        type="checkbox"
        [checked]="isSelected(item.key)"
        [disabled]="isCheckboxDisabled(item.key)"
        (change)="toggleSelection(item.key)"
      />
      <label for="" class="item-label">{{ item.name }}</label>
    </div>
  </div>
</div>
